<template>
    <div class="fadein">
        <div class="h30"></div>
        <div class="center1200 bg-white temp-1 shadow">
            <div class="h20"></div>
            <div class="center-title">
              <span v-if="movies.length>0"><a href="#"><img class="title-pic" src="/static/img/title-left.png" alt=""> {{keyword}} <img class="title-pic" src="/static/img/title-right.png" alt=""></a></span>
              <span v-else><a href="#"><img class="title-pic" src="/static/img/title-left.png" alt=""> 暂无数据 <img class="title-pic" src="/static/img/title-right.png" alt=""></a></span>
              
            </div>
            <div class="h20"></div>
            <div class="movieboxes" v-if="movies.length>0">
              <div class="moviebox" v-for="v in movies">
                <a href="javascript:;" @click="movieDetail(v.id)">
                  <img :src="v.cover" alt="" class="moviepic" />
                </a>
                <a href="" @click="movieDetail(v.id)">{{v.title}}</a>
                <p>
                  <span >
                    {{v.pubdates}}
                  </span>
                </p>
              </div>
              <div style="width:172px;" v-for="n in flex_movies_align"></div>
            </div>
            
            <!-- <div class="categorys">
              <div class="category" v-for="n in 12"><a href="" style="display: block;">category{{n}}</a></div>
            </div> -->
      
            <div class="h10"></div>
      
          </div>
        <div class="h30"></div>
        <Goback></Goback>

    </div>
</template>
<script>
  import Goback from '@/components/components/goback'
  export default{
    components:{
        Goback,

    },
    data(){
      return {
        keyword:'',
        movies:[
        ],
        flex_movies_align:0,
      }
    },
    watch:{
      $route(newVal,oldVal){
        this.movies = [];
        if(newVal.name == 'categorydetail'){
          this.$parent.activeIndex = '3'
        }
        this.keyword = this.$route.params.keyword
      },
      keyword(){
        
        this.getmovies();
      }
    },
    methods:{
      //根据分类获取电影
      getmovies(){
        this.keyword = this.$route.params.keyword
        
        $.ajax({
          url:'//'+ this.$API_URL +'/api/v1/types',
          type:'get',
          data:{keyword:this.keyword},
          success:(ret)=>{
            
            if(ret.data.length>0){
              this.movies = ret.data[0].withmovies;
              
              this.flex_movies_align = 6 - (this.movies.length % 6)
            }else{
              // this.movies = "暂无数据"
              this.movies = []
            }
            
          }
        })
      },
      movieDetail(id){
        // 
        this.$router.push('/movie/'+id);
      },
    },
    mounted() {
      this.$parent.activeIndex = '3'
      this.getmovies();
    } 
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/categorydetail.vue